export enum Series {
  series01 = 'total compensation',
  series02 = 'salary',
  series03 = 'company earnings',
}
